<template>
  <div class="bullet-proofs-wrapper">
    <div class="bullet-proofs-des">
      <div class="decoration left top"></div>
      <div class="decoration right top"></div>
      <div class="decoration left bottom"></div>
      <div class="decoration right bottom"></div>
      <div class="large-icon"></div>
      <div class="content">
        <div class="title-bar">
          <div class="title">零知识证明</div>
          <div class="hint">
            <span class="el-icon-warning-outline"></span
            >&nbsp;本算法数值均需要使用小于2的64次方的非负整数；所有计算结果必须为非负整数
          </div>
          <div class="fill"></div>
          <instruction-btn
            :id="instruction.excellent.bulletproofs.id"
            :instruction-info="instruction.excellent.bulletproofs.instructionInfo"
            tool-tip-placement="left"
          ></instruction-btn>
        </div>
        <div class="describe">
          Bulletproofs
          零知识范围证明的能力，保证了数据隐私性、链上透明性和数据可操作性。Bulletproofs
          零知识范围证明可以利用 Pedersen 承诺算法将明文数值隐藏，实现数据加密。同时 Pedersen
          承诺是一个支持同态加法、减法、部分乘法运算的算法，因此在对已经制成承诺的数据进行运算时，不使用“解密-运算-加密”流程，而是直接对承诺进行计算。
        </div>

        <div class="instruction-des">
          使用方法：请先在区块链部署零知识证明智能合约，生成密钥后即可使用该加解密工具。
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" :tab-position="tabPosition">
      <el-tab-pane label="生成随机因子" name="init">
        <el-alert
          title="用户可以生成随机因子，随机因子用于后续生成证明"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <init v-if="activeName == 'init'" ref="init"></init>
      </el-tab-pane>
      <el-tab-pane label="生成证明" name="prove">
        <el-alert title="用户可以对输入的数据生成一个证明" type="info" show-icon :closable="false">
        </el-alert>
        <prove v-if="activeName == 'prove'" ref="prove"></prove>
      </el-tab-pane>

      <el-tab-pane label="验证证明" name="proveVerify">
        <el-alert
          title="用户通过第二步生成的证明和承诺，去验证这个证明的有效性"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <proveVerify v-if="activeName == 'proveVerify'" ref="proveVerify"></proveVerify>
      </el-tab-pane>

      <el-tab-pane label="验证一致性" name="pedersenVerify">
        <el-alert
          title="用户可以在这里验证三种参数（数值、承诺和随机因子）的有效一致性"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <pedersenVerify v-if="activeName == 'pedersenVerify'" ref="pedersenVerify"></pedersenVerify>
      </el-tab-pane>
      <el-tab-pane label="链上数据计算" name="contractCompute">
        <el-alert
          title="用户可以在这一步进行数据计算并且上链，这里会生成随机因子为用户生成证明，在区块交易信息中也会显示证明而不是数值本身，从而起到保护隐私的作用"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <contractCompute
          v-if="activeName == 'contractCompute'"
          ref="contractCompute"
        ></contractCompute>
      </el-tab-pane>
      <el-tab-pane label="链下数据计算" name="proveMethod">
        <el-alert
          title="用户在这里可以通过第五步得到的随机因子和证明在链下进行计算，目的是为了验证链上计算的结果是否准确"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <proveMethod v-if="activeName == 'proveMethod'" ref="proveMethod"></proveMethod>
      </el-tab-pane>

      <el-tab-pane label="验证计算结果" name="contractQueryAndVerify">
        <el-alert
          title="用户在这里输入链下计算后的结果证明，并提交链上验证，此接口为异步"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <contractQueryAndVerify
          v-if="activeName == 'contractQueryAndVerify'"
          ref="contractQueryAndVerify"
        ></contractQueryAndVerify>
      </el-tab-pane>

      <el-tab-pane label="查询验证结果" name="contractVerifyQuery">
        <el-alert
          title="用户在这里可以查询第七步的验证结果"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <contractVerifyQuery
          v-if="activeName == 'contractVerifyQuery'"
          ref="contractVerifyQuery"
        ></contractVerifyQuery>
      </el-tab-pane>
    </el-tabs>

    <contractDetail ref="contractDetail"></contractDetail>
  </div>
</template>
<script>
import instruction from '@/instruction/index'
import contractDetail from './contractDetail'
import init from './init'
import prove from './prove'
import proveVerify from './proveVerify'
import proveMethod from './proveMethod'
import pedersenVerify from './pedersenVerify'
import contractCompute from './contractCompute'
import contractQueryAndVerify from './contractQueryAndVerify'
import contractVerifyQuery from './contractVerifyQuery'

export default {
  name: 'Index',
  components: {
    contractDetail,
    init,
    prove,
    proveVerify,
    proveMethod,
    pedersenVerify,
    contractCompute,
    contractQueryAndVerify,
    contractVerifyQuery
  },
  data() {
    return {
      activeName: 'init',
      tabPosition: 'top',
      keyspath: '',
      paramspath: '',
      path: '',
      kpath: '',
      collapseText: 'describe',
      keyArr: [],
      instruction,
      chainId: ''
    }
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.chainId = val
        this.getContractDetact()
      }
    }
  },
  mounted() {
    this.chainId = this.$store.state.computing.chainId
    //this.getContractDetact()
  },
  methods: {
    getContractDetact() {
      let params = {
        chainid: this.chainId
      }
      this.$apis.bulletproofs.bulletproofsContractDetact(params).then(res => {
        if (res.errors[0].code == 40011) {
          this.$refs.contractDetail.handleOpen(res.data)
        }
      })
    },

    refresh() {
      this.getContractDetact()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.bullet-proofs-wrapper {
  @include adaptation(
    (
      --common-gap-4: 4px,
      --common-gap-8: 8px,
      --common-gap-12: 12px,
      --common-gap-16: 16px,
      --common-gap-32: 32px,
      --common-gap-56: 56px,
      --common-pos-neg-offset: -1.5px,
      --decoration-border-width: 3px,
      --decoration-width: 32px,
      --decoration-height: 28px,
      --large-icon-width: 137px,
      --large-icon-height: 137px,
      --title-bar-height: 26px,
      --title-hint-line-height: 20px
    )
  );
  .bullet-proofs-des {
    color: var(--base-color-text-primary);
    background-color: var(--base-background-color-light);
    border: var(--base-border-width) solid var(--base-border-color-light);
    padding: var(--common-gap-16) var(--common-gap-56) var(--common-gap-16) var(--common-gap-32);
    position: relative;
    display: flex;
    align-items: center;

    .decoration {
      border: var(--decoration-border-width) solid transparent;
      position: absolute;
      width: var(--decoration-width);
      height: var(--decoration-height);
      &.left {
        left: var(--common-pos-neg-offset);
        border-left-color: var(--base-color-notice);
      }

      &.top {
        top: var(--common-pos-neg-offset);
        border-top-color: var(--base-color-notice);
      }

      &.right {
        right: var(--common-pos-neg-offset);
        border-right-color: var(--base-color-notice);
      }

      &.bottom {
        bottom: var(--common-pos-neg-offset);
        border-bottom-color: var(--base-color-notice);
      }
    }

    .large-icon {
      background-image: url('~@/assets/images/excellent/bulletproofs-large-icon.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      min-width: var(--large-icon-width);
      margin-right: var(--common-gap-32);
      height: var(--large-icon-height);
    }

    .content {
      align-self: flex-start;
      margin-top: var(--common-gap-8);
      display: flex;
      flex-direction: column;
      height: calc(var(--large-icon-height) - var(--common-gap-8));

      .title-bar {
        display: flex;
        align-items: center;
        height: var(--title-bar-height);
        line-height: var(--title-bar-height);
        margin-bottom: var(--common-gap-16);

        .title {
          margin-right: var(--common-gap-16);
          font-weight: 700;
          font-size: var(--base-font-size-extra-large);
        }

        .fill {
          flex-grow: 1;
        }

        .hint {
          color: var(--base-color-notice-light-2);
          align-self: flex-end;
          line-height: var(--title-hint-line-height);
        }
      }

      .describe {
        color: var(--base-color-text-regular);
        flex-grow: 1;
      }

      .instruction-des {
        display: flex;
        align-items: center;
        &::before {
          content: '';
          width: var(--common-gap-4);
          height: var(--common-gap-4);
          margin-right: var(--common-gap-4);
          border-radius: 50%;
          background-color: var(--base-color-notice-light-2);
        }
      }
    }
  }
  .el-alert {
    margin-bottom: var(--common-gap-16);
  }
}
</style>
